/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { postToController } from '../../../actions/apiActions';
import { handleNextStep, handleStepBack, setFnolReducer, setIsFinanced, setSelectedFinanceHouse, setVehicleRegConfirm, setVehicleRegNumber } from '../../../actions/claimSubmitActions';
import { showCallMeModal } from '../../../actions/modalActions';
import { REGESTRATION_NUMBER_FILTERS } from '../../../constants/registrationNumberFilter';

class FnolStep9Sub1ConfirmCarDetails extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.handleChangeRegistration = this.handleChangeRegistration.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleToggleTC = this.handleToggleTC.bind(this);
        this.handleIsFinanced = this.handleIsFinanced.bind(this);
        this.getFinanceHouses = this.getFinanceHouses.bind(this);
        this.handleFinanceSelection = this.handleFinanceSelection.bind(this);
        this.handleSelectedFinanceHouseDropdownToggle = this.handleSelectedFinanceHouseDropdownToggle.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.handleKeyup = this.handleKeyup.bind(this);
        this.openFinance = this.openFinance.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleBack = this.handleBack.bind(this);

        this.state = {
            carRegNumber: this.props.claimSubmit.selectedRiskItem.riskItems[0].vehicleDetails.registrationNumber,
            carYear: this.props.claimSubmit.selectedRiskItem.riskItems[0].vehicleDetails.year,
            carColour: this.props.claimSubmit.selectedRiskItem.riskItems[0].vehicleDetails.colour,
            isVehicleFinanced: undefined,
            financeHouseList: [],
            selectList: [],
            selectedFinanceHouse: "",
            selectedFinanceHouseId: -1,
            selectedFinanceHouseDropdown: false,
            selectedItem: this.props.claimSubmit.selectedFinanceHouse,
            vehicleRegistrationConfirm: false,
            financeHouseText: "",
            submitted: false
        };
    }

    handleCallMeBack() {
        this.props.dispatchShowCallMeBack()
    }

    openFinance() {
            this.setState({ isFinanceOpen: true })
    }

    async handleSubmit() {
        this.setState({ submitted: true });
        await this.props.dispatchHandleNextStep();
    }

    async handleBack() {
        await this.props.dispatchHandleStepBack();
    }

    handleChangeRegistration(e: any) {
        let value = e.target.value;
        this.props.dispatchSetVehicleRegNumber(value);
    }

    checkStep1Answers() {
        if (this.state.hasCause && this.state.hasDate && this.state.hasTimeChanged && this.state.name && this.state.contact) {
            this.setState({ Step1Disabled: false })
        }
        else {
            this.setState({ Step1Disabled: true })
        }
    }

    async handleToggleTC() {
        this.props.dispatchSetVehicleRegConfirm(!this.props.claimSubmit.vehicleRegistrationConfirm)
    }

    handleIsFinanced(isVehicleFinanced) {
        this.props.dispatchIsVehicleFinance(isVehicleFinanced)
    }

    async handleFinanceSelection(e: any) {
        let selectedFinanceHouseItem = this.state.financeHouseList.filter(function (item) {
            return item.id == e
        })
        await this.setState({
            selectedFinanceHouse: selectedFinanceHouseItem[0].description,
            selectedFinanceHouseId: selectedFinanceHouseItem[0].id,
        });
        await this.props.dispatchAction(setFnolReducer("selectedFinanceHouse", selectedFinanceHouseItem[0].id))
        await this.setState({ nextDisabled: selectedFinanceHouseItem[0] === undefined });
    }

    async getFinanceHouses() {
        await postToController(this.props.dispatch, 'GetFinanceHouses', JSON.stringify({ Parameter: this.props.profile.countryId })).then(async (response) => {
            await this.setState({
                financeHouseList: response,
                selectList: response
            });
            return true;
        })
    }

    async handleSelectedFinanceHouseDropdownToggle(e: any) {
        await this.setState({
            selectedFinanceHouseDropdown: !this.state.selectedFinanceHouseDropdown
        });
    }

    async componentDidMount() {
        let regNumber = this.props.claimSubmit.claimVehicleRegNo !== '' ? this.props.claimSubmit.claimVehicleRegNo : this.props.claimSubmit.selectedRiskItem.riskItems[0].vehicleDetails.registrationNumber;

        if (REGESTRATION_NUMBER_FILTERS.filter(x => x.Keyword.trim().toLowerCase() === regNumber.trim().toLowerCase()).length > 0) {
            await this.setState({ carRegNumber: '' });
            await this.props.dispatchSetVehicleRegNumber('');
        }
        else if (this.props.claimSubmit.claimVehicleRegNo == '' && this.props.claimSubmit.selectedRiskItem.riskItems[0].vehicleDetails.registrationNumber != '') {
            await this.props.dispatchSetVehicleRegNumber(this.props.claimSubmit.selectedRiskItem.riskItems[0].vehicleDetails.registrationNumber);
        }

        if (this.state.financeHouseList.length === 0) {
            await this.getFinanceHouses();
        }
        if (this.props.claimSubmit.selectedFinanceHouse != '') {
            await this.setState({
                financeHouseText: this.props.claimSubmit.selectedFinanceHouse.description
            });
        } 
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        await this.setState({ selectedItem: text });
        await this.setState({ selectList: [] });

        if (text && text.length >= 1) {
            var selectListTemp = this.state.financeHouseList.filter(x => x.description.toLowerCase().includes(text.toLowerCase()));
            this.props.dispatchSelectedFinanceHouse(text);
            await this.setState({
                selectList: selectListTemp});
        }
        else {
            await this.setState({ selectList: this.state.financeHouseList });
            this.props.dispatchSelectedFinanceHouse("");
        }
        await this.setState({
            financeHouseText: text
        });
    }

    handleKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ selectList: this.state.financeHouseList });
            return false;
        }
    }

    selectItem(item) {
        this.setState({
            selectList: [],
            financeHouseText : item.description});
        this.props.dispatchSelectedFinanceHouse(item);
    }

    public render() {
        var continueDisabled = false;
        if ((this.props.claimSubmit.claimVehicleRegNo == '' || !this.props.claimSubmit.vehicleRegistrationConfirm || this.props.claimSubmit.isVehicleFinanced == '') || (this.props.claimSubmit.isVehicleFinanced == 'yes' && !this.props.claimSubmit.selectedFinanceHouse.description)) {
            continueDisabled = true;
        }

        return (
            <div className="col ssp-container-fnol-drivable ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-drivable">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                {this.props.claimSubmit.isCar && <h3>Confirm car details</h3>}
                                {!this.props.claimSubmit.isCar && <h3>Confirm motorbike details</h3>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        <hr className="hr-minus21px" />
                        <div className="mb-20px">
                            {(this.props.claimSubmit.isCar) && <p className="mb-0px line-height-1-43">Please confirm your car's details below, you can edit the details that are incorrect</p>}
                            {(!this.props.claimSubmit.isCar) && <p className="mb-0px line-height-1-43">Please confirm your motorbike's details below, you can edit the details that are incorrect</p>}
                        </div>
                        <div className="ssp-form" id="CarDetailsCorrect">
                            <div className={'form-group ' + (this.state.submitted && this.props.claimSubmit.claimVehicleRegNo !== "" ? 'has-error' : '')}>
                                <label className={'form-label' + (this.state.carRegNumber !== "" ? '' : ' no-opacity')}>Reg no. (required)</label>
                                <input placeholder="Reg no." id="regNumberInput" className={'form-control ' + (this.props.claimSubmit.claimVehicleRegNo !== "" ? 'form-control-error' : 'underline')} name="carRegNumber" value={this.props.claimSubmit.claimVehicleRegNo} onChange={this.handleChangeRegistration} />
                                {this.props.claimSubmit.claimVehicleRegNo === "" &&
                                    <div className="form-inline-error">Registration no. required</div>
                                }
                            </div>
                            <div className="row noma" id="isInfoCorrect">
                                <div className="nopa">
                                    <label className="switch">
                                        <input type="checkbox" id="confirmToggle" checked={this.props.claimSubmit.vehicleRegistrationConfirm} onClick={this.handleToggleTC} />
                                        <span className="slider-signup round"></span>
                                    </label>
                                </div>
                                <div className="col nopa">
                                    <p className="switch-normal font-weight-normal line-height-normal nopa ml-12px pt-lg-5px mb-0px">I confirm that my registration number is correct</p>
                                </div>
                            </div>
                            <div className={'form-group disabled' + (this.state.submitted && !this.state.carYear ? 'has-error' : '')}>
                                <p className="font-weight-normal line-height-normal mb-6px">Year</p>
                                <p className="font-size-16px font-weight-bold mb-0px" id="vehicleYear">{this.state.carYear} </p>
                                <hr className="mt-8 mb-20px greyed-out-hr"/>
                            </div>
                            <div className={'form-group disabled' + (this.state.submitted && !this.state.carColour ? 'has-error' : '')}>
                                <p className="font-weight-normal line-height-normal mb-6px">Color</p>
                                <p className="font-size-16px font-weight-bold mb-0px" id="vehicleColour">{this.state.carColour}</p>
                                <hr className="mt-10px greyed-out-hr"/>
                            </div>
                            <div className="mb-20px mt-20px">
                                <p className="mb-0px line-height-1-43">Is your info not correct? Please <a className="font-weight-bold text-red" onClick={this.handleCallMeBack}>click here</a> to request a call back to update your details.</p>
                            </div>
                            <div className="mb-6px">
                                <p className="mb-0px font-weight-normal line-height-normal">Please select yes or no to continue</p>
                            </div>
                            <div className="row noma car-details-claims-parent-row">
                                <div className="col-lg-9 nopa">
                                    <p className="text-16 font-weight-bold line-height-normal glassclaims-intro-p">Is your {this.props.claimSubmit.isCar ? "car" : "motorbike" } currently financed?</p>
                                </div>
                                <div className="nopa text-lg-right glassclaims-button-col">
                                    <div className="row noma glassclaims-button-row">
                                        <div className="col nopa glassclaims-button-yes">
                                            <button id="btnIsFinancedYes" className={this.props.claimSubmit.isVehicleFinanced == 'yes' ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} onClick={() => this.handleIsFinanced('yes')}>Yes</button>
                                        </div>
                                        <div className="glassclaims-mobile-gutter nopa"></div>
                                        <div className="col nopa glassclaims-button-no">
                                            <button id="btnIsFinancedNo" className={this.props.claimSubmit.isVehicleFinanced == 'no' ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} onClick={() => this.handleIsFinanced('no')}>No</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.props.claimSubmit.isVehicleFinanced == 'yes' &&
                                <div className="row noma mt-31px">
                                    <div className="mb-6px mb-mobile-20px col-12 nopa">
                                        <p className="font-weight-normal line-height-normal mb-0px">Who is it financed by? If you can't find your financer, select "Not listed"</p>
                                    </div>
                                    <div className="col-12 nopa car-details-fuzzy-search">
                                        <input
                                            type="text"
                                            id="autocomplete"
                                            onChange={this.autocomplete}
                                            onKeyUp={this.handleKeyup}
                                            value={this.state.financeHouseText}
                                            onFocus={this.openFinance}
                                            className="custom-input form-control"
                                            placeholder="Start typing or choose from the list"
                                        />
                                        {this.state.selectList.length > 0 && this.state.isFinanceOpen && (
                                            <ul id="makeAndModel" className="list-group">
                                                {this.state.selectList.map((item, idx) => (
                                                    <li
                                                        className={
                                                            this.state.cursor === idx ? "active list-group-item" : "list-group-item"
                                                        }
                                                        key={idx}
                                                        onClick={() => this.selectItem(item)}
                                                    >
                                                        {item.description}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                        {this.state.selectedItem === "" || this.state.selectedItem === undefined &&
                                            <div className="help-block mt-0">Finance house is required</div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="col-12 nopa fnol-where-it-happened-buttonholder">
                        <button className="btn btn-solid-red fnol-where-it-happened-button-next" id="btn-info-next" disabled={continueDisabled} onClick={this.handleSubmit}>Confirm</button>
                        <button className="btn btn-outline-red fnol-where-it-happened-button-back" id="btn-info-back" onClick={this.handleBack}>Back</button>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchIsVehicleFinance: (isVehicleFinanced) => dispatch(setIsFinanced(isVehicleFinanced)),
        dispatchSetVehicleRegConfirm: (value) => dispatch(setVehicleRegConfirm(value)),
        dispatchSelectedFinanceHouse: (selectedItem) => dispatch(setSelectedFinanceHouse(selectedItem)),
        dispatchSetVehicleRegNumber: (data) => dispatch(setVehicleRegNumber(data)),
        dispatchShowCallMeBack: () => dispatch(showCallMeModal(true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep9Sub1ConfirmCarDetails)